module.exports = __webpack_public_path__ + "assets/img/twentyea-logo-convey.069b42e8.png";